import store from '../store';
import { getValue } from '../connectSelector';

import {
  selectCurrentDeliveryOptionId,
  selectCurrentAddressId,
  selectCurrentShippingId,
  selectCurrentPaymentOptionId,
  selectCurrentInstallmentId,
  selectDeliveryOptions
} from './selectors';

import {
  setDeliveryOption,
  setAddress,
  setShippingOption,
  setPaymentOption,
  setInstallment,
  setFundsTransferAccount,
  setCreditPaymentOption,
  setPayOnDeliveryMethod,
  setMasterPassInstallment,
  setHasRewards,
  setWalletHepsiPaySelectionPage,
  setWalletPaymentPage
} from './actions';

export const DeliveryOptionSelectionPage = context => {
  const hasDeliveryOption = getValue(selectCurrentDeliveryOptionId);
  if (hasDeliveryOption) {
    return;
  }

  const { delivery_options: deliveryOpts } = context;
  if (!deliveryOpts || !deliveryOpts.length) {
    return;
  }

  const defaultDelivery = deliveryOpts.find(option => option.delivery_option_type === 'customer');
  const deliveryPk = defaultDelivery ? defaultDelivery.pk : deliveryOpts[0].pk;

  store.dispatch(setDeliveryOption(deliveryPk));
};

export const AddressSelectionPage = context => {
  const { addresses } = context;

  if (addresses && addresses.length) {
    const selectedAddress = getValue(selectCurrentAddressId);
    if (selectedAddress && addresses.find(({ pk }) => selectedAddress === pk)) {
      return;
    }

    const primaryAddress = addresses.find(address => !!address.primary);

    if (primaryAddress) {
      store.dispatch(setAddress(primaryAddress.pk));
      return;
    }

    store.dispatch(setAddress(addresses[0].pk));
  }
};

export const ShippingOptionSelectionPage = context => {
  const deliveryOptions = getValue(selectDeliveryOptions);
  const retailStoreDeliveryOption = deliveryOptions.find(option => option.delivery_option_type === 'retail_store');
  const currentDeliveryOptionId = getValue(selectCurrentDeliveryOptionId);
  const hasSelectedShipping = getValue(selectCurrentShippingId);

  if (hasSelectedShipping && currentDeliveryOptionId !== retailStoreDeliveryOption?.pk) {
    return;
  }

  const { shipping_options: shippingOpts } = context;
  let selectedShippingOpt = shippingOpts[0];

  if (shippingOpts && shippingOpts.length) {
    if (currentDeliveryOptionId === retailStoreDeliveryOption?.pk
      && shippingOpts.find(opt => opt.slug === 'RetailStore')) {
      selectedShippingOpt = shippingOpts.find(opt => opt.slug === 'RetailStore');
    }

    store.dispatch(setShippingOption(selectedShippingOpt.pk));
  }
};

export const PaymentOptionSelectionPage = context => {
  const hasSelectedPayment = getValue(selectCurrentPaymentOptionId);
  if (hasSelectedPayment) {
    return;
  }

  const { payment_options: paymentOpts } = context;
  if (!paymentOpts || !paymentOpts.length) {
    return;
  }

  const storedCardOption = paymentOpts.find(option => option.payment_type === 'stored_card');
  const paymentPk = storedCardOption ? storedCardOption.pk : paymentOpts[0].pk;

  store.dispatch(setPaymentOption(paymentPk));
};

export const InstallmentSelectionPage = context => {
  const hasSelectedInstallment = getValue(selectCurrentInstallmentId);
  if (hasSelectedInstallment) {
    return;
  }

  const { installments } = context;
  if (installments && installments.length) {
    store.dispatch(setInstallment(installments[0].pk));
  }
};

export const CreditCardConfirmationPage = context => {
  const { has_rewards } = context;

  store.dispatch(setHasRewards(has_rewards));
};

export const CreditCardThreeDSecurePage = context => {
  const { redirect_url } = context;
  const isMobileApp = false; //localStorage.getItem('isMobileApp'); // disable iframe detection due to ios18 issue
  const triggerMobile3DEvent = localStorage.getItem('triggerMobile3DEvent');

  if (redirect_url) {
    if (isMobileApp) {
      if (triggerMobile3DEvent) {
        document.dispatchEvent(new CustomEvent('open-3d-iframe',
          {
            detail: { redirect_url }
          }
        ));
      } else {
        const iframeWrapper = document.createElement('div');
        const iframe = document.createElement('iframe');
        const closeButton = document.createElement('div');

        const iframeURLChange = (iframe, callback) => {
          iframe.addEventListener('load', () => {
            setTimeout(() => {
              if (iframe?.contentWindow?.location) {
                callback(iframe.contentWindow.location);
              }
            }, 0);
          });
        };

        const removeIframe = async () => {
          const iframeSelector = document.querySelector('.js-checkout-payment-iframe-wrapper');

          if (!iframeSelector) {
            return;
          }

          iframeSelector.remove();

          const iframeLoading = document.createElement('div');

          iframeLoading.className = 'iframe-loading-wrapper js-iframe-loading-wrapper';
          document.body.appendChild(iframeLoading);

          await fetch(`${window.URLS.checkout}`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json'
            }
          });

          iframeLoading.remove();
        };

        iframeWrapper.className = 'checkout-payment-iframe-wrapper js-checkout-payment-iframe-wrapper';
        closeButton.className =
          'checkout-payment-iframe-wrapper-close-button js-checkout-payment-iframe-wrapper-close-button';

        const iframeSelector = document.querySelector('.js-checkout-payment-iframe-wrapper');

        iframe.setAttribute('src', redirect_url);

        closeButton.innerHTML = '&#x2715';
        closeButton.addEventListener('click', removeIframe);

        iframeWrapper.append(iframe, closeButton);

        if (iframeSelector === null) {
          document.body.appendChild(iframeWrapper);

          iframeURLChange(iframe, (location) => {
            if (location.origin !== window.location.origin) {
              return false;
            }

            const searchParams = new URLSearchParams(location.search);
            const isOrderCompleted = location.href.includes('/orders/completed');
            const data = {
              url: location.pathname
            };

            if (searchParams.has('success') || isOrderCompleted) {
              removeIframe();
            }

            if (isOrderCompleted) {
              window.parent.ReactNativeWebView.postMessage(JSON.stringify(data));
            }
          });
        }
      }
    } else {
      document.location.href = redirect_url;
    }
  }
};

export const FundsTransferChoicePage = context => {
  const { bank_accounts } = context;
  if (bank_accounts && bank_accounts.length) {
    store.dispatch(setFundsTransferAccount(bank_accounts[0].pk));
  }
}

export const WalletSelectionPage = context => {
  const isHepsipaySuccess = context?.paymentData?.data?.Success;
  
  if (isHepsipaySuccess) {
    store.dispatch(setWalletHepsiPaySelectionPage());
  }
};

export const WalletPaymentPage = () => {
  store.dispatch(setWalletPaymentPage());
}

export const CreditPaymentSelectionPage = context => {
  const { credit_payment_options } = context;
  if (credit_payment_options && credit_payment_options.length) {
    store.dispatch(setCreditPaymentOption(credit_payment_options[0].pk));
  }
}

export const CreditPaymentCompletePage = context => {
  const { redirect_url } = context;
  if (redirect_url) {
    if (redirect_url.includes('redirection')){
      const urlObj = new URL(redirect_url);
      const urlSearchParams = new URLSearchParams(urlObj.search);
  
      urlSearchParams.append('t', new Date().getTime());
      document.location.href = `${urlObj.origin}${urlObj.pathname}?${urlSearchParams.toString()}`;
    } else {
      document.location.href = redirect_url;
    }
  }
}

export const PayOnDeliveryPaymentChoicePage = context => {
  const { payment_choices } = context;
  if (payment_choices && payment_choices.length) {
    store.dispatch(setPayOnDeliveryMethod(payment_choices[0].value));
  }
}

export const ThankYouPage = context => {
  if (context.redirect_url) {
    window.location.replace(context.redirect_url);
  }
};

export const MasterpassInstallmentPage = context => {
  const { installments } = context;
  if (installments && installments.length) {
    store.dispatch(setMasterPassInstallment(installments[0].pk));
  }
};
